import { type SVGProps } from "react";

import { cn } from "@/shared/helpers/cn.helper";

interface UploadSquareIconProps extends SVGProps<SVGSVGElement> {
  className?: string;
}

export const UploadSquareIcon = ({ className, ...props }: UploadSquareIconProps) => (
  <svg
    className={cn("text-light-400", className)}
    fill="none"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M3 20.4V3.6C3 3.26863 3.26863 3 3.6 3H20.4C20.7314 3 21 3.26863 21 3.6V20.4C21 20.7314 20.7314 21 20.4 21H3.6C3.26863 21 3 20.7314 3 20.4Z"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <path
      d="M6 18L18 18"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
    <path
      d="M12 14V6M12 6L15.5 9.5M12 6L8.5 9.5"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
  </svg>
);

export default UploadSquareIcon;
